import { render } from "./PolicyGroupCard.vue?vue&type=template&id=93288812&scoped=true"
import script from "./PolicyGroupCard.vue?vue&type=script&lang=js"
export * from "./PolicyGroupCard.vue?vue&type=script&lang=js"

import "./PolicyGroupCard.vue?vue&type=style&index=0&id=93288812&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93288812"]])

export default __exports__